export const readMeButtonStyles = (props) =>({
    readMeButton: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #686868',
        borderRadius: '10px',
        color: '#5F2E05',
        fontFamily: 'Roboto',
        fontWeight: '600',
        fontSize: '14px',
        minWidth: '133px !important',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#FFFFFF',
            border: '1px solid #686868',
            color: '#5F2E05',
        },
    },
})
